import(/* webpackMode: "eager" */ "/app/src/app/company/careers/frontend-developer/page.tsx");
